import { trackFirebase } from '@otto-ec/apps-api/thirdpartytracking';

export interface FirebaseItem {
    articleNumber: string;
    itemName: string;
    variationId: string;
    itemCategory: string;
    price: number;
    quantity: number;
}

export interface FirebaseData {
    total: number;
    orderId: string;
    customerId: string;
    items: FirebaseItem[];
}

export class FireBaseBridge {
    constructor() {}

    emitEvent(eventName: string, itemId: string, itemName: string, productBaseClass: string, quantity: number): void {
        trackFirebase({
            event_name: eventName,
            event_params: {
                items: [{ item_id: itemId, item_name: itemName, item_category: productBaseClass, quantity }]
            }
        });
    }

    emitEventWithTotal(eventName: string, { items, orderId, customerId, total }: FirebaseData): void {
        trackFirebase({
            event_name: eventName,
            event_params: {
                value: total,
                currency: 'EUR',
                transaction_id: orderId,
                customer_id: customerId,
                items: items.map(item => ({
                    item_id: item.articleNumber,
                    item_name: item.itemName,
                    item_variant: item.variationId,
                    item_category: item.itemCategory,
                    price: item.price,
                    quantity: item.quantity
                }))
            }
        });
    }

    emitAddToBasketEvent(event: AddToBasketEvent): void {
        try {
            this.emitEvent('add_to_cart', event.articleNumber, event.itemName, event.itemCategory, event.addedQuantity);
        } catch (e) {
            if (window.o_global.debug.status().activated) {
                console.error(e);
            }
        }
    }

    static initialize(): void {
        const o_order = window.o_order ?? {};

        o_order.firebaseBridge = o_order.firebaseBridge ?? new FireBaseBridge();
    }
}

export interface AddToBasketEvent {
    articleNumber: string;
    itemName: string;
    itemCategory: string;
    addedQuantity: number;
}
